export function InternalError() {
  return (
    <svg
      width='124'
      height='124'
      viewBox='0 0 124 124'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <g clipPath='url(#clip0_2284_32850)'>
        <mask
          id='mask0_2284_32850'
          style={{ maskType: 'alpha' }}
          maskUnits='userSpaceOnUse'
          x='0'
          y='0'
          width='124'
          height='124'
        >
          <rect width='124' height='124' rx='62' fill='#2F3B4D' />
        </mask>
        <g mask='url(#mask0_2284_32850)'>
          <rect width='124' height='124' rx='62' fill='#F5F8F9' />
          <path
            d='M41.6177 91.7979L35.621 97.7945L29.6244 91.7979L35.621 85.9065'
            stroke='#AF292E'
            strokeWidth='1.74038'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M17.012 120.22C16.3746 119.588 15.8687 118.836 15.5235 118.007C15.1782 117.178 15.0005 116.29 15.0005 115.392C15.0005 114.494 15.1782 113.605 15.5235 112.777C15.8687 111.948 16.3746 111.196 17.012 110.564L32.6528 95.0588'
            stroke='#AF292E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M43.7232 61.1832L66.5524 83.802M49.0886 66.5486L55.2956 60.3416M61.0818 78.4366L67.394 72.1244M64.1327 81.3824L54.0332 91.4819C52.3438 93.1271 50.079 94.0477 47.7209 94.0477C45.3629 94.0477 43.098 93.1271 41.4087 91.4819L36.1485 86.2217C35.3087 85.3989 34.6415 84.4168 34.1861 83.3329C33.7306 82.249 33.496 81.0852 33.496 79.9095C33.496 78.7338 33.7306 77.5699 34.1861 76.4861C34.6415 75.4022 35.3087 74.4201 36.1485 73.5973L46.1429 63.6029L64.1327 81.3824Z'
            stroke='#AF292E'
            strokeWidth='1.74038'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <line
            x1='55.8203'
            y1='82.6132'
            x2='51.7907'
            y2='86.6428'
            stroke='#AF292E'
            strokeWidth='1.74038'
            strokeLinecap='round'
          />
          <path
            d='M85.8027 35.7241L91.7994 29.7274L97.796 35.7241L91.7994 41.6155'
            stroke='#AF292E'
            strokeWidth='1.74038'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M113.581 2.19862C114.347 2.95902 114.956 3.86368 115.371 4.86043C115.786 5.85719 116 6.92629 116 8.00609C116 9.08588 115.786 10.155 115.371 11.1517C114.956 12.1485 114.347 13.0532 113.581 13.8136L94.7676 32.4629'
            stroke='#AF292E'
            strokeWidth='2'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <path
            d='M83.6989 66.3386L60.8696 43.7198M63.2893 46.1395L73.3889 36.0399C75.0782 34.3947 77.3431 33.4741 79.7012 33.4741C82.0592 33.4741 84.3241 34.3947 86.0134 36.0399L91.2736 41.3001C92.1134 42.1229 92.7805 43.105 93.236 44.1889C93.6914 45.2728 93.926 46.4366 93.926 47.6123C93.926 48.788 93.6914 49.9519 93.236 51.0358C92.7805 52.1196 92.1134 53.1017 91.2736 53.9246L81.2792 63.9189L63.2893 46.1395Z'
            stroke='#AF292E'
            strokeWidth='1.74038'
            strokeLinecap='round'
            strokeLinejoin='round'
          />
          <line
            x1='71.6016'
            y1='44.9085'
            x2='75.6311'
            y2='40.879'
            stroke='#E71613'
            strokeWidth='1.74038'
            strokeLinecap='round'
          />
          <g style={{ mixBlendMode: 'multiply' }}>
            <path
              d='M54.9663 35.0447V39.6857M36.4023 55.9292H41.0433M39.303 40.2658L42.7837 43.1664'
              stroke='#E71613'
              strokeWidth='1.74038'
              strokeLinecap='round'
            />
          </g>
          <g style={{ mixBlendMode: 'multiply' }}>
            <path
              d='M72.3706 92.4773L72.3706 88.4164M90.9346 72.1729L86.2936 72.1729M88.6141 88.4164L85.7134 85.5158'
              stroke='#E71613'
              strokeWidth='1.74038'
              strokeLinecap='round'
            />
          </g>
        </g>
        <g style={{ mixBlendMode: 'color' }}>
          <rect width='124' height='124' fill='#2F3B4D' />
        </g>
      </g>
      <defs>
        <clipPath id='clip0_2284_32850'>
          <rect width='124' height='124' rx='62' fill='white' />
        </clipPath>
      </defs>
    </svg>
  );
}
